import * as actionTypes from './actionTypes';

interface State {
  isFetching: boolean;
  error: boolean;
  isLogout: boolean;
}

const initialState: State = {
  isFetching: false,
  error: false,
  isLogout: false
}

export const logout = (state: State = initialState, action) => {
  switch(action.type) {
    case actionTypes.FETCH_LOGOUT_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_LOGOUT_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_LOGOUT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        isLogout: true
      }
    case actionTypes.SET_LOGOUT_VALUE:
      return {
        isLogout: action.value
      }
    default:
      return state;
  }
}
